import React, { useEffect, useState } from "react";
import "../../Styles/Pages/superadmin_dashboard.css";
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import instance from "../../utils/api";
import ReactApexChart from "react-apexcharts";
import Chart from "react-apexcharts";
import Topbar from "../../Layouts/Admin_layout/Admin_topbar";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const Admin_dashboard = () => {
  const [dashboardData, setDashboardData] = useState();
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const navigate = useNavigate();

  const getAllData = async (year) => {
    try {
      const response = await instance.get(
        `/dashboard/VendorDashboard?year=${year}`
      );
      setDashboardData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllData(selectedYear);
  }, [selectedYear]);

  const handleYearChange = (newValue) => {
    if (newValue) {
      setSelectedYear(newValue.year());
    }
  };

  const options = {
    labels: ["Active", "Inactive"],
    colors: ["#19864A", "#F24E1E"],
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "50px",
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              fontSize: "16px",
              color: "#323232",
              fontWeight: "700",
              fontFamily: "Poppins",
              lineHeight: "21.78px",
            },
          },
        },
      },
    },
  };

  const chartOptions = {
    series: [
      {
        name: "Fields Count",
        data: dashboardData?.fields_month_counts,
        color: "#00A651",
      },
    ],
    options: {
      chart: {
        height: 500,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      yaxis: {
        title: {
          text: "Farmers Count",
          // offsetX: -5, // Adjust horizontal offset for title positioning
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#333",
          },
        },
      },
      grid: {
        row: {
          colors: ["#FFFFFF", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      legend: {
        position: "right",
        offsetY: 7,
        height: 230,
      },
    },
  };

  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Topbar />
      {dashboardData ? (
        <section className="superadmin_header">
          <div className="overview">Overview Section</div>
          <div className="dasboard-container">
            <Card
              onClick={() => navigate("/admin/FieldOfficers")}
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                height: "120px",
                cursor: "pointer",
              }}
            >
              <CardContent>
                <Typography className="text">Total Field Officers</Typography>
                <Typography className="text-value">
                  {dashboardData?.total_fieldofficers}
                </Typography>
              </CardContent>
            </Card>
            <Card
              onClick={() => navigate("/admin/Fields")}
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                cursor: "pointer",
              }}
            >
              <CardContent>
                <Typography className="officer-text">Total Fields</Typography>
                <Typography className="officer-text-value">
                  {dashboardData?.total_fields}
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                height: "120px",
              }}
            >
              <CardContent>
                <Typography className="records-text">
                  Total Checkouts
                </Typography>
                <Typography className="records-text-value">
                  {dashboardData?.total_checkouts}
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                height: "120px",
              }}
            >
              <CardContent>
                <Typography className="records-text" style={{ color: "#DE3163" }}>
                  Total Month Count
                </Typography>
                <Typography className="records-text-value" style={{ color: "#DE3163" }}>
                  {/* {dashboardData?.fields_month_counts} */}0
                </Typography>
              </CardContent>
            </Card>
          </div>
          <div className="pie-chart-section">
            <div className="charts-section">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={5}>
                  <div className="piechart">
                    <Typography variant="h5">Field Officers Status</Typography>
                    <Chart
                      options={options}
                      series={[
                        dashboardData?.active_fieldofficers,
                        dashboardData?.inactive_fieldofficers,
                      ]}
                      type="donut"
                      height={200}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={7}>
                  <div className="wavechart">
                    <Typography variant="h5" className="linechart-header">
                      Fields Trend
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          views={['year']}
                          label="Year"
                          value={dayjs(`${selectedYear}-01-01`)}
                          onChange={handleYearChange}
                          slotProps={{ textField: { size: 'small', sx: { width: "100px", marginBottom: "2px" } } }}
                        />
                      </LocalizationProvider>
                    </Typography>
                    <ReactApexChart
                      options={chartOptions.options}
                      series={chartOptions.series}
                      type="line"
                      height={200}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Admin_dashboard;
